import { trackEvent } from 'dibs-tracking';

type TrackDesignFeaturePayload = {
    action: string;
    label: 'profile' | 'project' | 'photo' | 'directory';
};

export const trackDesignFeature = ({ action, label }: TrackDesignFeaturePayload): void => {
    trackEvent({
        action,
        label,
        category: 'design features',
    });
};

type TrackViewProfileClickPayload = {
    action: 'photo' | 'trade directory';
};

export const trackViewProfileClick = ({ action }: TrackViewProfileClickPayload): void => {
    trackEvent({
        action,
        category: 'design features',
        label: 'view profile clicked',
    });
};

type TrackContactDesignerPayload = {
    label: 'profile' | 'directory';
};

export const trackContactDesignerClick = ({ label }: TrackContactDesignerPayload): void => {
    trackDesignFeature({
        action: 'contact designer clicked',
        label,
    });
};

export const trackContactDesignerSubmit = ({ label }: TrackContactDesignerPayload): void => {
    trackDesignFeature({
        action: 'contact designer submitted',
        label,
    });
};

type TrackShareProfilePayload = {
    label: 'profile' | 'project' | 'photo';
    shareType: 'email' | 'pinterest' | 'facebook' | 'twitter';
};

export const trackShareProfile = ({ label, shareType }: TrackShareProfilePayload): void => {
    trackDesignFeature({
        action: `share profile - ${shareType}`,
        label,
    });
};
